export class EmailVerification {
	uid: string;
	token: string;

	constructor(uid: string, token: string) {
		this.uid = uid;
		this.token = token;
	}
}
